document.addEventListener("DOMContentLoaded", (event) => {
	const hasCounter = document.querySelector(".dc-number-counter-card");
	if (hasCounter) {
		initCounter();
		function initCounter() {
			const sections = document.querySelectorAll(".et_pb_section:has(.dc-number-counter-card)");

			let options = {
				threshold: 0.5,
			};
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const counters = entry.target.querySelectorAll(".dc-number-counter-card");
						counters.forEach((counter) => {
							const percent = counter.querySelector(".percent-value");
							const percentValue = percent.innerText;
							counter.setAttribute("data-value", percentValue);
							const value = +counter.getAttribute("data-value");
							if (!value) return;
							percent.innerText = 0;
							counter.classList.add("show");
							const updateCounter = () => {
								const c = +percent.innerText;
								const interval = 300;
								const increment = percentValue / interval;
								if (c < percentValue) {
									percent.innerText = `${Math.ceil(c + increment)}`;
									setTimeout(updateCounter, 1);
								} else {
									percent.innerText = percentValue;
									observer.unobserve(entry.target);
								}
							};
							updateCounter();
						});
					}
				});
			}, options);
			sections.forEach((section) => observer.observe(section));
		}
	}
});
